/**
 * External Dependants
 */
import React from 'react';
import Page from 'page';
import classNames from 'classnames';

/**
 * Inernal Dependants
 */
import Icon from 'components/icon';

const Item = ({ label = '', path = '', selected = false, icon = null, onNavigate, className, children }) => {

    const classes = classNames('topbar__menu-item', className, { selected: selected });
    
    return (

        <li className={classes}>
            <a className="topbar__menu-link" style={{ background: 'transparent' }} href={path} onClick={onNavigate}>
                {icon && <Icon className='topbar__menu-icon' {...icon} />}
                <span className='topbar__menu-link-text menu-link-text'>
                    {label}
                </span>
            </a>
            {children}
        </li>
    );
};

export default Item;
